import { defineMessages } from 'react-intl';

export default defineMessages({
    doYouWishToContinue: {
        id: 'app.components.studentUnAssign.doYouWishToContinue',
        defaultMessage: 'Do you wish to continue?'
    }
});



// WEBPACK FOOTER //
// ./app/components/student-unassign/messages.js